<template>
    <transition name="fade" v-if="enableTool">
        <control-regulations
            :data-panel="pageID"
            :moduleCode="moduleCode"
            :posBtnMap="mapButtons.regulations.position"
            :idxBtnMap="mapButtons.regulations.order"
            :showLabelBtnMap="mapButtons.regulations.showLabel"
            :collapsible="mapButtons.regulations.collapsible"
            :collapsed="initialCollapsedExpandCollapse"
            :showButtonOnActionMap="false"
        >
        </control-regulations>
    </transition>
</template>

<script>
    import ToolMixin from './mixins/ToolMixin';

    export default {
        mixins: [
            ToolMixin,
        ],
        components: {
            ControlRegulations: () => import(/* webpackChunkName: "control-regulations" */ '@/components/maps/control/regulationsControl'),
        },
        data() {
            return {
                pageID: 'regulations'
            }
        },
    }
</script>